import PropTypes from 'prop-types';
import React from 'react';
import * as Ui from './ItemCard.styles';

const ItemCard = ({ title, meta, badge, imageSrc, imageAlt }) => (
  <Ui.Container>
    <Ui.ImageWrapper>
      {badge && <Ui.TypeBadge>{badge}</Ui.TypeBadge>}
      <Ui.ItemImage src={imageSrc} alt={imageAlt} />
    </Ui.ImageWrapper>
    <Ui.CardInfo>
      {title && <Ui.ItemName>{title}</Ui.ItemName>}
      {meta.map((line, index) => (
        <Ui.MetaRow key={line.label || index}>
          {line.label && <Ui.MetaLabel>{line.label}:</Ui.MetaLabel>}
          <Ui.MetaValue>{line.value}</Ui.MetaValue>
        </Ui.MetaRow>
      ))}
    </Ui.CardInfo>
  </Ui.Container>
);

ItemCard.propTypes = {
  title: PropTypes.string,
  meta: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
    }),
  ),
  badge: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};

ItemCard.defaultProps = {
  title: undefined,
  meta: [],
  badge: undefined,
};

export default ItemCard;
